import styled from "styled-components";

export const SmallPreviewContainer = styled.div<{ minHeight?: number }>`
  width: 100%;
  height: 100%;
  min-height: ${({ minHeight }) => minHeight || "10rem"};
`;
